/**
 * Parse a string value to a boolean.
 * Returns true if the value is exactly "true" (case-sensitive), false otherwise.
 *
 * @param value - The string value to parse
 * @returns true if value === "true", false otherwise
 *
 * @example
 * parseBoolean("true") // returns true
 * parseBoolean("false") // returns false
 * parseBoolean("TRUE") // returns false (case-sensitive)
 * parseBoolean("") // returns false
 */
export const parseBoolean = (value: string): boolean => value === 'true'
